export default __webpack_public_path__ + "static/media/login_bg_diet@3x.a96b37a8.jpg";